'use strict';

var app = angular.module('app');

// Service for checkout the shopping cart to paypal or other sites.
app.factory('LangService', ['$http', function ($http) {

    function fallback() {
        return $http.get('/translations/it.json')
            .then(function (data) {
                return data.data;
            });
    }

    var get = function (lang) {
        return $http.get('/translations/' + lang + '.json')
            .then(function (data) {
                return data.data;
            }, fallback);
    };

    return {
        get: get
    }
}]);
